<template>
  <div class="flex flex-col md:flex-row md:h-screen bg-background">
    <Sidebar />
    <main class="flex-1 overflow-y-auto">
      <div class="container mx-auto p-4 sm:p-6 max-w-7xl">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'

export default {
  name: 'DashboardLayout',
  components: { Sidebar },
  created() {
    // Carrega dados iniciais ao entrar no dashboard (API externa)
    this.$store.dispatch('kpis/fetchAll')
  },
}
</script>

